export const PAGE_STATE = {
  SELECT_ASSETS: 'SELECT_ASSETS',
  SELECT_TAGS: 'SELECT_TAGS',
  CHART_PREVIEW: 'CHART_PREVIEW'
};

export const HEADERS = {
  MACHINE_SELECTED: 'machineDashboard.compareTags.headers.machineSelected',
  MACHINE_NOT_SELECTED: 'machineDashboard.compareTags.headers.machineNotSelected',
  EDIT_MODE: 'machineDashboard.compareTags.headers.editMode'
};

export const CHART_ACTIONS = {
  GET_COMPARE_TAGS_CHARTS_RESULTS: 'GET_COMPARE_TAGS_CHARTS_RESULTS',
  CREATE_COMPARE_TAGS_CHARTS: 'CREATE_COMPARE_TAGS_CHARTS'
};
